var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChrome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.30242 10.4478L4.22177 5.71395C6.14113 3.32686 9.02016 2.01234 11.9637 2.00025C13.6694 1.98815 15.4113 2.42363 16.996 3.33895C18.746 4.35508 20.0766 5.81476 20.9234 7.49218L12.6452 7.0567C10.3024 6.9196 8.07258 8.23815 7.30242 10.4478ZM8.62903 12.0002C8.62903 13.8631 10.1371 15.3712 12 15.3712C13.8629 15.3712 15.371 13.8631 15.371 12.0002C15.371 10.1373 13.8629 8.62928 12 8.62928C10.1371 8.62928 8.62903 10.1333 8.62903 12.0002ZM21.3266 8.40347L15.6935 8.69379C17.2218 10.4801 17.246 13.0567 15.9597 15.0325L11.4395 21.9841C13.3145 22.0849 15.246 21.6736 16.996 20.6575C21.3266 18.1575 23.0806 12.9156 21.3266 8.40347ZM7.39113 13.9196L3.62903 6.52041C2.60081 8.09299 2 9.98008 2 12.0002C2 17.0002 5.66129 21.1414 10.4476 21.8752L13.0161 16.843C10.6935 17.2785 8.45161 16.0043 7.39113 13.9196Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChrome);
export default __webpack_public_path__ + "static/media/chrome.d4fc7ecb3bb0fa25b8a4b394ce5a5ab0.svg";
export { ForwardRef as ReactComponent };